"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

exports.__esModule = true;

var Plugin_1 = require("../Plugin");

var shared_1 = require("../Plugin/api/shared");

var _flatten = require("lodash/flatten");

var _uniqBy = require("lodash/uniqBy");

var utils_1 = require("../common/utils");

var Diagnostic =
/** @class */
function () {
  function Diagnostic(_a) {
    var plugin = _a.plugin;

    var _this = this;
    /**
     * Установка сертификатов из контейнеров.
     * @param { IContainerCertInfo[] } conatinerCertInfos
     * @param { IInstallCertOptions } options
     * @return { ICertInstallResult[] }
     */


    this.installCertsFromContainers = function (containerCertInfos, options) {
      var promiseCreators = containerCertInfos.map(function (containerCertInfo) {
        return function () {
          var certificate = containerCertInfo.certificate;
          return _this.plugin.installCertificate(containerCertInfo, options).then(function () {
            return {
              certificate: certificate,
              installed: true
            };
          })["catch"](function (error) {
            return {
              certificate: certificate,
              installed: false,
              error: error
            };
          });
        };
      });
      return promiseSequential(promiseCreators).then(function (certificates) {
        return certificates.filter(Boolean);
      });
    };
    /**
     * Поиск сертификатов в контейнерах.
     * @param { IContainerSearchFilter } filter - Фильтр по типу и id криппровайдера
     * @return { IContainerCertInfo[] }
     */


    this.searchCertsInContainers = function (filter) {
      var _a = __assign({
        providerIds: []
      }, filter),
          providerType = _a.providerType,
          providerIds = _a.providerIds; // this.plugin.searchCryptoProviders(providerType).then(res => {});


      return _this.plugin.searchCryptoProviders(providerType) // выбираем нужные провайдеры если задан фильтр
      .then(function (providers) {
        var result = [];

        for (var _i = 0, providers_1 = providers; _i < providers_1.length; _i++) {
          var provider = providers_1[_i];

          if (provider.type === shared_1.CryptoProviderType.Pkcs11 || providerIds.includes(provider.id)) {
            result.push(provider);
          }
        }

        return result;
      }) // для каждого провайдера достаем массив контейнеров
      .then(function (providers) {
        return Promise.all(providers.map(function (provider) {
          return _this.plugin.getCryptoProviderContainers(provider).then(function (containers) {
            return containers.map(function (c) {
              return {
                name: c.name,
                pluginCertInfo: c.cert,
                provider: provider
              };
            });
          })["catch"](function (error) {
            console.error(error.message);
            return [];
          });
        }));
      }) // Для системных криптопровайдеров Crypto Pro GOST c id 75, 80, 81
      // возвращается один и тот же массив контейнеров.
      .then(function (arOfContainersArrays) {
        var containers = _flatten(arOfContainersArrays);

        var containersCryptoApi = _uniqBy(containers.filter(function (c) {
          return c.provider.type === shared_1.CryptoProviderType.CryptoApi;
        }), 'name');

        var containersPkcs11 = containers.filter(function (c) {
          return c.provider.type === shared_1.CryptoProviderType.Pkcs11;
        });
        return containersCryptoApi.concat(containersPkcs11);
      }).then(function (containers) {
        return containers.map(function (c) {
          try {
            return c.pluginCertInfo ? {
              name: c.name,
              provider: c.provider,
              certificate: new Plugin_1.PluginCertificate(c.pluginCertInfo)
            } : null;
          } catch (error) {
            console.error(error.message);
            return null;
          }
        }).filter(utils_1.notEmpty);
      });
    };

    this.plugin = plugin;
  }

  return Diagnostic;
}();

exports.Diagnostic = Diagnostic;

var promiseSequential = function promiseSequential(promiseCreators) {
  return promiseCreators.reduce(function (promise, promiseCreator) {
    return promise.then(function (result) {
      return promiseCreator().then(function (res) {
        return result.concat(res);
      });
    });
  }, Promise.resolve([]));
};